







































import { updateExternalAssignments } from '@adobe/edex/frontend/api/externalAssignment';

export default {
  name: 'bulk-actions',
  props: {
    selected: {
      default: () => {
        return new Set();
      },
      type: Set,
    },
  },
  data() {
    return {
      show: false,
      action: '',
      loading: false,
    };
  },
  computed: {
    hasSelected() {
      return Boolean(this.selected.size);
    },
  },
  watch: {
    selected(current, previous) {
      if (current.size === previous.size) {
        this.action = '';
      }
    },
  },
  methods: {
    selectAction(e) {
      this.action = e.target.value;
    },
    async submit() {
      let errorCount = 0;
      let successCount = 0;
      this.loading = true;
      const updatedRows = [];

      await Promise.all(
        [...this.selected].map(async (assignment_id) => {
          try {
            const payload = {
              assignment_id,
              assignment_status: this.action,
            };
            const { data } = await updateExternalAssignments(payload);
            if (data) {
              successCount += 1;
              updatedRows.push(data);
              if (errorCount + successCount === this.selected.size) {
                this.loading = false;
              }
            }
          } catch (error) {
            errorCount += 1;
            if (errorCount + successCount === this.selected.size) {
              this.$emit('onBulkActionError', errorCount);
              this.loading = false;
            }
          }
        })
      );
      this.$emit('onBulkActionSuccess', updatedRows);
    },
  },
};
